import React, { useState} from 'react';
import {
    Box, Collapse
} from '@mui/material';
import CampaignListItem from './CampaignListItem';
import CampaignCard from './CampaignCard';
import { Campaign, CampaignsListProps } from '../types/apps/Campaign';

const CampaignsList: React.FC<CampaignsListProps> = ({ campaigns }) => {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [viewedCampaign, setViewedCampaign] = useState<string | null>(null);
    const [open, setOpen] = React.useState(false);

    const handleClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        setViewedCampaign(index === selectedIndex ? null : campaigns[index].name);
        setSelectedIndex(index);
        setOpen(false);
    };

    const renderCampaign = (campaign: Campaign, index: number) => (
        <Box sx={{ mx: 2, mt: 2 }} key={campaign.name}>
            <CampaignListItem
                campaign={campaign}
                selectedIndex={selectedIndex}
                index={index}
                handleClick={handleClick}
            />
            <Collapse in={viewedCampaign === campaign.name} timeout="auto" unmountOnExit>
                <CampaignCard campaign={campaign} />
            </Collapse>
        </Box>
    );

    return (
        <Box sx={{ mx: 2, mt: 2 }}>
            {campaigns.map((campaign, index) => (
                renderCampaign(campaign, index))
            )}
        </Box>
    );
};

export default CampaignsList;